import { stringifyQs } from "@dashboard/utils/urls";

export const rfqSection = "/rfq/";

export const rfqListPath = rfqSection;
export const rfqListUrl = (params?: { status?: string }) =>
  rfqListPath + (params ? "?" + stringifyQs(params) : "");

export const rfqDetailPath = (id: string) => rfqSection + id;
export const rfqDetailUrl = (id: string) => rfqDetailPath(encodeURIComponent(id));
